import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import { PhoneInputFieldWUT } from '../../../ui/phone-input-field';
export const PhoneWUT = props => {
  return /*#__PURE__*/React.createElement(PhoneInputFieldWUT, _extends({}, props, {
    fieldType: FIELD_TYPES.PHONE
  }));
};
//# sourceMappingURL=phone-wut.js.map